import { LoadingButton } from "@mui/lab"
import { t } from "i18next"
import React, { useState } from "react"
import { PaymentModel } from "../../models/organisation/PaymentModel"
import { ModalMyVA } from "../companies/ModalMyVA"

export const PayNowButton: React.FC<{ payments: PaymentModel }> = ({ payments }) => {

    const [showVa, setShowVa] = useState(false)

    return (
        <>
            <LoadingButton onClick={() => setShowVa(true)} className={`primary-dark-gradient soft-box-shadow`} style={{ color: "white", padding: '10px 20px', borderRadius: 8, minWidth: 110 }}>
                {t('pay_now')}
            </LoadingButton>
            <ModalMyVA isOpen={showVa} onClose={() => setShowVa(false)} payments={payments} />
        </>
    )
}
